export * from "./ConsumablesProductHeading";
